import clsx from 'clsx';
import React, { useCallback } from 'react';

import chevronDown from 'images/chevron_down_icon.svg';

import { useCloseElOnOutsideClick } from '../../../hooks';
import navLinkStyles from '../NavLinks/styles.module.scss';
import styles from './styles.module.scss';

interface Option {
  title: string;
  url: string;
}

export default function NavDropdown({
  dropdownShown,
  fullWidth,
  highlighted = false,
  inSideNav,
  options,
  setDropdownShown,
  title,
}: {
  dropdownShown: string;
  fullWidth?: boolean;
  highlighted?: boolean;
  inSideNav: boolean;
  options: Option[];
  setDropdownShown: React.Dispatch<React.SetStateAction<string>>;
  title: string;
}) {
  const dropdownIdentifier = inSideNav ? `side${title}` : title;
  const isOpen = dropdownShown === dropdownIdentifier;
  const closeDropdown = useCallback(() => setDropdownShown(''), [setDropdownShown]);

  const { ref: dropdownRef } = useCloseElOnOutsideClick({ closeFn: closeDropdown, isOpen });

  const toggleDropdown = () => {
    isOpen ? closeDropdown() : setDropdownShown(dropdownIdentifier);
  };

  return (
    <div
      className={clsx({ [styles.relativeContainer]: !fullWidth && !inSideNav })}
      ref={dropdownRef}
    >
      <div
        className={clsx(styles.dropdownOpener, navLinkStyles.navLink)}
        onClick={toggleDropdown}
        data-test={`nav-dropdown-${title}`}
      >
        <span
          className={clsx(styles.dropdownText, {
            'text-red': highlighted,
          })}
        >
          {title}
        </span>
        <img
          src={chevronDown}
          width="10"
          className={clsx(styles.chevronDown, {
            [styles.dropdownClosed]: !isOpen && !highlighted,
            [styles.dropdownOpen]: isOpen,
            [styles.highlightedDropdown]: highlighted && !isOpen,
            [styles.rotateNinety]: inSideNav,
          })}
        />
      </div>
      {options.length > 0 && (
        <div
          className={clsx(styles.dropdown, {
            [styles.fullWidthDropdown]: fullWidth,
            [styles.show]: isOpen,
            [styles.sideNavDropdown]: inSideNav,
          })}
        >
          {options.map((option) => (
            <span key={option.title} className={styles.dropdownLink}>
              <a href={option.url}>{option.title}</a>
            </span>
          ))}
        </div>
      )}
    </div>
  );
}
